import React from "react";
import Router from "@/component/Router";

import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "@/entry/appearance.css";

import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';

ModuleRegistry.registerModules([AllCommunityModule]);

// main application component
export const App = React.memo(() => {
    return (
        <Router/>
    );
});

export default App;